var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2 52.3004C77.6 51.8004 75.9 52.7004 75.4 54.3004C73.3 61.1004 68.3 66.8005 61.7 69.9005C53.6 73.6005 44.4 72.8005 37.2 68.1005C44.4 65.7005 51.6 62.8005 57.3 60.1005C74.2 52.3005 101.6 36.4005 97 26.4005C94.8 21.7005 87 21.0005 73.6 24.5005C64.5 15.2005 50.3 12.3005 38 17.9005C25.8 23.6005 18.7 36.4005 19.8 49.4005C8.50003 57.4005 3.80003 63.8005 6.00003 68.6005C8.50003 74.1005 18.7 73.4004 30.1 70.3004C39.4 78.7004 52.9 80.9005 64.4 75.5005C72.5 71.8005 78.6 64.8004 81.3 56.3004C81.7 54.5004 80.8 52.7004 79.2 52.3004ZM25.1 65.0005C16 67.1005 12.3 66.3004 11.4 65.8004C11.6 64.8004 13.5 61.4004 20.9 55.8004C21.1 56.4004 21.3 57.1005 21.5 57.7005C22.1 59.3005 23.9 60.1005 25.4 59.4005C27 58.8005 27.8 57.0005 27.1 55.4005C22.4 42.9005 28.2 28.7005 40.3 23.2005C51.5 18.0005 64.9 21.8005 71.8 31.9005C66.1 36.1005 58.3 40.6005 49.9 44.4005C48.4 45.1005 47.7 46.9005 48.4 48.4005C49.1 49.9005 50.9 50.6005 52.4 49.9005C62.3 45.3005 71.5 39.9005 77.6 35.0005C78.7 34.1005 79.1 32.4005 78.4 31.1005C78.1 30.5005 77.7 30.0005 77.4 29.4005C86.5 27.3005 90.3 28.0005 91.2 28.6005C91 29.5005 89.2 32.9005 81.7 38.6005C74.7 43.8005 65.1 49.4004 54.4 54.3004C44.1 59.3004 33.7 63.1005 25.1 65.0005Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 6.3999C76.9 8.28999 75.4104 9.7999 73.6 9.7999C71.7896 9.7999 70.3 8.28999 70.3 6.3999C70.3 4.50981 71.7896 2.99991 73.6 2.99991C75.4104 2.99991 76.9 4.50981 76.9 6.3999Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 35.2999C7.8 36.6254 6.72548 37.6999 5.4 37.6999C4.07452 37.6999 3 36.6254 3 35.2999C3 33.9744 4.07452 32.8999 5.4 32.8999C6.72549 32.8999 7.8 33.9744 7.8 35.2999Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 91.3004C39.7 94.4484 37.148 97.0004 34 97.0004C30.852 97.0004 28.3 94.4484 28.3 91.3004C28.3 88.1523 30.852 85.6004 34 85.6004C37.148 85.6004 39.7 88.1523 39.7 91.3004Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6 67.8998C95.6 69.8328 94.033 71.3998 92.1 71.3998C90.167 71.3998 88.6 69.8328 88.6 67.8998C88.6 65.9668 90.167 64.3998 92.1 64.3998C94.033 64.3998 95.6 65.9668 95.6 67.8998Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 9.79956C27.4 11.4012 26.1016 12.6996 24.5 12.6996C22.8984 12.6996 21.6 11.4012 21.6 9.79956C21.6 8.19794 22.8983 6.89957 24.5 6.89957C26.1016 6.89957 27.4 8.19794 27.4 9.79956Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 91.8003C77.1 92.6839 76.3837 93.4003 75.5 93.4003C74.6164 93.4003 73.9 92.6839 73.9 91.8003C73.9 90.9166 74.6164 90.2003 75.5 90.2003C76.3837 90.2003 77.1 90.9166 77.1 91.8003Z",
    fill: "#E6F7FF",
    stroke: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/Saturn.f010371ccafcb0534f0c181a293f7809.svg";
export { ForwardRef as ReactComponent };